export const receiveOrderModal = "ReceiveOrderModal";
export const estimatedReceiveDateModal = "EstimatedReceiveDateModal";
export const scheduleDeliveryModal = "ScheduleDeliveryModal";
export const unscheduleDeliveryModal = "UnscheduleDeliveryModal";
export const deliveryDateHistoryLogsModal = "DeliveryDateHistoryLogsModal";
export const timeframeEntryModal = "TimeframeEntryModal";
export const cancelOrderModal = "CancelOrderModal";
export const uncancelOrderModal = "UncancelOrderModal";
export const copyOrderModal = "CopyOrderModal";
export const orderCompletionModal = "OrderCompletionModal";
export const notesModal = "NotesModal";
export const addOrderToTruckModal = "AddOrderToTruckModal";
export const removeOrderFromTruckModal = "RemoveOrderFromTruckModal";
export const messageCustomerModal = "MessageCustomerModal";
export const loadActivitiesModal = "LoadActivitiesModal";
export const truckAuditLogModal = "TruckAuditLogModal";
export const timeframeOptimizationModal = "timeframe-opt-modal";
export const pendingChargesModal = "pending-charges-modal";
export const accessorialChargesModal = "accessorial-charges-modal";
export const barcodeTransactionsModal = "barcode-transactions-modal";
export const barcodeMapModal = "BarcodeMapModal";
export const imagesModal = "ImagesModal";
export const imageUploadModal = "ImageUploadModal";
export const companyEntryModal = "company-entry-modal";
export const consigneeEntryModal = "consignee-entry-modal";
export const consigneeContactEntryModal = "ConsigneeContactEntryModal";
export const editReferenceModal = "edit-reference-modal";
export const newReferenceModal = "new-reference-modal";
export const companySelectorModal = "CompanySelectorModal";
export const addressVerificationStatusModal = "AddressVerificationStatusModal";
export const addNoteModal = "AddNoteModal";
export const truckOrderViewModal = "TruckOrderViewModal";
export const consigneeContactSearchModal = "ConsigneeContactSearchModal";
export const orderAuditTrailModal = "OrderAuditTrailModal";
export const addTruckModal = "AddTruckModal";
export const deleteTruckModal = "DeleteTruckModal";
export const finalizeTruckModal = "FinalizeTruckModal";
export const unfinalizeTruckModal = "UnfinalizeTruckModal";
export const customerNotReadyModal = "CustomerNotReadyModal";
export const updateOrderInstructionsModal = "UpdateOrderInstructionsModal";
export const advancedSearchModal = "AdvancedSearchModal";
export const manageFacilitySavedSearchesModal = "ManageFacilitySavedSearchesModal";
export const truckMapViewModal = "TruckMapViewModal";
export const deliveryExportModal = "DeliveryExportModal";
export const completedOrderExportModal = "CompletedOrderExportModal";
export const documentUploadModal = "DocumentUploadModal";
export const orderPreviewModal = "OrderPreviewModal";
export const driverManifestModal = "DriverManifestModal";
export const setBulkOrdersWantsAsapModal = "SetBulkOrdersWantsAsapModal";
export const actionSummaryModal = "ActionSummaryModal";
export const columnVisabilityModal = "ColumnVisabilityModal";
export const editCommodityModal = "EditCommodityModal";
export const manageOrderFiltersModal = "ManageOrderFiltersModal";
export const manualConsolidationWizardModal = "ManualConsolidationWizardModal";
export const mapModal = "MapModal";
export const newTruckModal = "NewTruckModal";
export const overrideTimeModal = "OverrideTimeModal";
export const saveAsModal = "SaveAsModal";
export const updateSearchModal = "UpdateSearchModal";
export const addOrderPalletsModal = "AddOrderPalletsModal";
export const deleteTruckTemplateModal = "DeleteTruckTemplateModal";
export const barcodeSystemCurrentFacilityModal = "BarcodeSystemCurrentFacilityModal";
export const loadViewModal = "LoadViewModal";
export const unlockLoadModal = "UnlockLoadModal";
export const consolidateLoadsModal = "ConsolidateLoadsModal";
export const manifestViewModal = "ManifestViewModal";
export const hideManifestModal = "HideManifestModal";
export const restoreManifestModal = "RestoreManifestModal";
export const barcodeOrderViewModal = "BarcodeOrderViewModal";
export const receiveBarcodeOrderModal = "ReceiveBarcodeOrderModal";
export const loadBarcodeOrderModal = "LoadBarcodeOrderModal";
export const deliverBarcodeOrderModal = "DeliverBarcodeOrderModal";
export const stockOrderViewModal = "StockOrderViewModal";
export const receiveStockOrderModal = "ReceiveStockOrderModal";
export const cancelStockOrderModal = "CancelStockOrderModal";
export const unlockStockOrderModal = "UnlockStockOrderModal";
export const inventoryItemViewModal = "InventoryItemViewModal";
export const resolveMissingInventoryItemModal = "ResolveMissingInventoryItemModal";
export const palletViewModal = "PalletViewModal";
export const bulkInventoryItemViewModal = "BulkInventoryItemViewModal";
export const createBarcodeOrderFromHeaderNumberModal = "CreateBarcodeOrderFromHeaderNumberModal"
export const linkInventoryToOrderModal = "LinkInventoryToOrderModal"
export const modelLinkSummaryModal = "ModelLinkSummaryModal";
export const stockAdjustmentViewModal = "StockAdjustmentViewModal";
export const customerOnHoldModal = "CustomerOnHoldModal";
